import React from 'react';
import { Panel } from '@deque/cauldron-react';
import styles from './ZeroStatePanel.css';

interface Props {
  children: React.ReactNode;
}

const ZeroStatePanel: React.FC<Props> = ({ children }) => {
  return <Panel className={styles.wrap}>{children}</Panel>;
};

export default ZeroStatePanel;
